export default "__VITE_ASSET__CLFRNB91__"